import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { PaymentType } from "@/domain/payment-type.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class PaymentTypeService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: PaymentType): Promise<PaymentType> => {
    return httpClient
      .request<PaymentType>({
        url: `${this.urlApiBase}/payment-type`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: PaymentType): Promise<PaymentType> => {
    return httpClient
      .request<PaymentType>({
        url: `${this.urlApiBase}/payment-type/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<PaymentType> => {
    const url = `${this.urlApiBase}/payment-type/${id}`;

    return httpClient
      .request<PaymentType>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<PaymentType>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/payment-type${query}`;

    return httpClient
      .request<IPaginateVueTable<PaymentType>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<PaymentType[]> => {
    const url = `${this.urlApiBase}/payment-type/list-active`;

    return httpClient
      .request<PaymentType[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<PaymentType> => {
    const url = `${this.urlApiBase}/payment-type/${id}`;

    return httpClient
      .request<PaymentType>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
